<div class="input-container" [class.error]="showError">
  <label class="title">
    {{ title() }}
    @if (required()) {
      <span class="required">*</span>
    }
  </label>
  <input
    [(ngModel)]="value"
    [type]="type()"
    [attr.aria-label]="placeholder() | translate"
    [placeholder]="placeholder() | translate"
    [disabled]="disabled"
    (input)="inputHandler($event)"
    [maxlength]="max()"
    [appInputPattern]="pattern()"
    [pastePattern]="pastePattern()"
    [autocomplete]="autocomplete()"
  >
  @if (showError && inputErrors) {
    @for (error of inputErrors; track error) {
      <div class="error-text">
        {{ listOfErrors[error] | translate }}
      </div>
    }
  }
</div>
